import { render, staticRenderFns } from "./ProductPromotionDialog.vue?vue&type=template&id=56eeee7b&scoped=true"
import script from "./ProductPromotionDialog.vue?vue&type=script&lang=js"
export * from "./ProductPromotionDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductPromotionDialog.vue?vue&type=style&index=0&id=56eeee7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eeee7b",
  null
  
)

export default component.exports